import { createMuiTheme } from '@material-ui/core/styles';
import merge from 'lodash/merge';

import palette from './palette';
import typography from './typography';
import color from './color';

const muiTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: [
      'OVOCircular Book',
      'Futura',
      'Century Gothic',
      'sans-serif',
    ].join(','),
  },
  palette,
  color,
  spacing: 16,
});

muiTheme.typography = merge(
  muiTheme.typography,
  typography(muiTheme.typography)
);

// Overrides
muiTheme.overrides = {
  MuiContainer: {
    root: {
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  },
  MuiTypography: {
    gutterBottom: {
      marginBottom: muiTheme.spacing(1), // 16px
    },
    colorInherit: {
      color: 'inherit',
    },
    h1: {
      [muiTheme.breakpoints.down('sm')]: {
        fontSize: muiTheme.typography.pxToRem(56),
      },
      [muiTheme.breakpoints.down('xs')]: {
        fontSize: muiTheme.typography.pxToRem(40),
      },
      color: '#0A9828',
    },
    h2: {
      [muiTheme.breakpoints.down('sm')]: {
        fontSize: muiTheme.typography.pxToRem(48),
      },
      [muiTheme.breakpoints.down('xs')]: {
        fontSize: muiTheme.typography.pxToRem(32),
      },
      color: '#0A9828',
    },
    h3: {
      [muiTheme.breakpoints.down('sm')]: {
        fontSize: muiTheme.typography.pxToRem(21),
      },
      [muiTheme.breakpoints.down('xs')]: {
        fontSize: muiTheme.typography.pxToRem(18),
      },
    },
    h4: {
      color: '#0A9828',
    },
    subtitle1: {
      [muiTheme.breakpoints.down('sm')]: {
        fontSize: muiTheme.typography.pxToRem(14),
      },
    },
    body1: {
      [muiTheme.breakpoints.down('sm')]: {
        fontSize: muiTheme.typography.pxToRem(14),
      },
    },
    body2: {
      [muiTheme.breakpoints.down('sm')]: {
        fontSize: muiTheme.typography.pxToRem(12),
      },
    },
  },
};

export default muiTheme;
